import {
	mainnet,
	arbitrum,
	bitlayer,
	bitlayerTestnet,
	type Chain,
} from "viem/chains";

import type { RuntimeMode, } from "@types";
import type { ValidChainId, } from "@bracket/types";


export const chains = new Map<ValidChainId, Chain>([
	[ 1, mainnet ],
	[ 42161, arbitrum ],
	[ 200810, bitlayerTestnet ],
	[ 200901, bitlayer ],
]);


export const DEFAULT_CHAIN_ID: ValidChainId = 1;
export const DEFAULT_RUNTIME_MODE: RuntimeMode = "PROD";
